<template>
  <div class="standard-detail">
    <div class="detail__header">
      <img
        class="detail__header-img"
        :src="`${imgPrefix}${standard.headerImgUrl}`"
      />
      <!-- 达标有礼 -->
      <div
        v-if="activityCode === 1002"
        class="detail__header-btn"
        @click="onReceive"
      >
        立即领取
      </div>
      <!-- 周三惠客 -->
      <div v-else-if="activityCode === 1003 || activityCode === 1007" class="detail__header-benefit">
        <div class="detail__header-price">
          <div class="detail__header-orgprice">
            <span>原价：</span>
            <span class="detail__header-orgyuan"
              >{{ fenToYuan(standard.originalPrice) }}元</span
            >
          </div>
          <div class="detail__header-curprice">
            秒杀价：{{ fenToYuan(standard.price) }}元
          </div>
        </div>
        <div class="detail__header-btn" @click="onBuy">立即购买</div>
      </div>
       <!-- 积分商城 -->
      <div
        v-else-if="activityCode === 1001"
        class="detail__header-btn"
        @click="onReceive"
      >
          立即兑换
      </div>
      <div
        v-else-if="activityCode === 1006"
        class="detail__header-btn detail__header-btn__exam"
        @click="onReceive"
      >
          立即领取
      </div>
    </div>
    <div class="detail__content">
      <div class="detail__content-title">{{ standard.name }}</div>
      <div class="detail__content-text" v-html="standard.description"></div>
    </div>
    <!-- <van-popup
      v-model:show="showWechatPayPopup"
      round
      position="bottom"
      :style="{ height: '384px' }"
    >
      <div>请输入支付密码</div>
    </van-popup> -->
  </div>
</template>

<script>
import { onMounted, reactive, toRef } from 'vue'
import { Dialog, Toast } from 'vant'
import { useRouter, useRoute } from 'vue-router'

import globalVariables from '@/utils/globalVariables'
import { isInWxBrowser } from '@/utils/wechatUtil'
import { fenToYuan } from '@/utils'
import useWechat from '@/utils/useWechat'
import api from '@/api'

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()

    let { id, activityCode } = route.query
    const { state } = useWechat(`${id},${activityCode}`)

    if (state) {
      id = state.split(',')[0]
      activityCode = state.split(',')[1]
    }

    onMounted(() => {
      data.activityCode = Number.parseInt(activityCode)

      api
        .getProductDetail({
          activityCode,
          id
        })
        .then(res => {
          data.standard = res.data
        })
    })

    // 上面的过程走完，说明openid已经获取到了
    const data = reactive({
      standard: {
        id: -1,
        name: '',
        thumbnailUrl: '',
        headerImgUrl: '',
        detailImgUrl: '0',
        productType: 1,
        description: '0',
        originalPrice: 0,
        price: 0
      },
      activityCode: ''
      // showWechatPayPopup: false
    })

    const onReceive = () => {
      Dialog.confirm({
        title: '确认领取',
        message: data.standard.name
      }).then(() => {
        api
          .place({
            activityCode,
            activityGiftId: data.standard.activityGiftId
          })
          .then(res => {
            if (res.error) {
              Toast.fail(res.error.message)
              return
            }
            Toast.success('领取成功')

            router.push({
              path: '/orderDetail',
              query: {
                orderCode: res.data.orderCode
              }
            })
          })
          .catch(err => {
            console.log(err)
          })
      })
    }

    const onBuy = () => {
      if (!isInWxBrowser()) {
        Toast.fail('请在微信中打开, 否则无法领取')
        return
      }

      Dialog.confirm({
        title: '确认购买',
        message: data.standard.name
      }).then(async () => {
        try {
          const res = await api.place({
            activityCode,
            activityGiftId: data.standard.activityGiftId
          })
          if (res.error) {
            Toast.fail(res.error.message)
            return
          }
          globalVariables.isFromProductDetailPage = true
          router.push({
            path: '/orderDetail',
            query: {
              orderCode: res.data.orderCode
            }
          })
        } catch (err) {
          Toast.fail(err)
          Toast.clear()
        }
      })
    }

    return {
      imgPrefix: globalVariables.imgPrefix,
      standard: toRef(data, 'standard'),
      isReceived: toRef(data, 'isReceived'),
      activityCode: toRef(data, 'activityCode'),
      // showWechatPayPopup: toRef(data, 'showWechatPayPopup'),

      fenToYuan,

      onReceive,
      onBuy
    }
  }
}
</script>

<style lang="less" scoped="scoped">
.standard-detail {
  min-height: 100vh;
  background: #f5f5f5;
  .detail__header {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 19px;
    .detail__header-img {
      width: 229px;
      height: 148px;
      margin-top: 21px;
    }
    .detail__header-btn {
      width: 104px;
      height: 30px;
      background: #d80c18;
      border-radius: 15px;

      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;

      margin-top: 13px;
    }
    .detail__header-btn:active {
      opacity: 0.8;
    }
    .detail__header-btn__exam {
      background: #2798FE;
    }
    .detail__header-benefit {
      display: flex;
      width: 375px;
      margin-top: 11px;
      align-items: flex-end;
      .detail__header-price {
        margin-left: 36px;
        flex: 1;
        .detail__header-orgprice {
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;

          color: #333333;
          .detail__header-orgyuan {
            text-decoration: line-through;
          }
        }
        .detail__header-curprice {
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #d80c18;
          margin-top: 8px;
        }
      }
      .detail__header-btn {
        margin-right: 36px;
      }
    }
  }
  .detail__content {
    background: #ffffff;
    border-radius: 8px;
    width: 349px;
    margin: 8px 13px;
    overflow: hidden;
    .detail__content-title {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 15px;
    }
    .detail__content-text {
      margin: 13px 8px;
      padding: 4px 8px;
      font-size: 12px;
      line-height: 22px;
      white-space: pre-wrap;
      letter-spacing: 1px;
    }
  }
}
</style>


<style lang="less" >
.detail__content-text h1 {
  font-size: 14px;
  line-height: 24px;
  margin: 0;
  padding: 0;
}
</style>